import React from 'react'
import PropTypes from "prop-types";

import ChartSection from './ChartSection';
import GroupedBarGraph from './Charts/GroupedBarGraph';
function BarGraphSection({ title, description, data, options }) {
  return (
    <ChartSection
      title={title}
      description={description}
    >
      <GroupedBarGraph options={options} data={data} />
    </ChartSection>
  )
}

BarGraphSection.propTypes = {
  title: PropTypes.shape({}),
  description: PropTypes.shape({}),
  data: PropTypes.shape({}),
  options: PropTypes.shape({}),
};

BarGraphSection.defaultProps = {
  title: undefined,
  description: undefined,
  data: undefined,
  options: undefined
}


export default BarGraphSection;